<!--  -->
<template>
	<div class="mybtnbox">
		<button type="button" class="follow" v-if="!state" @click="setfollow">关注</button>
		<button type="button" class="follow1" v-if="state" @click="setfollow">已关注</button>
	</div>
</template>

<script>
	//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
	//例如：import 《组件名称》 from '《组件路径》';

	export default {
		//import引入的组件需要注入到对象中才能使用
		components: {},
		props: ["follow", "id"],
		data() {
			//这里存放数据
			return {
				state: this.follow
			};
		},
		//监听属性 类似于data概念
		computed: {},
		//监控data中的数据变化
		watch: {
			state(val) {
				this.state = this.val;
			}
		},
		//方法集合
		methods: {
			setfollow() {
				if (!this.follow) {
					this.$http
						.post("user/setfo/", {
							id: this.id,
							token: this.$cookies.get("token")
						})
						.then(res => {
							if (res.body.code == 1) {
								this.state = false;
							}
						});
				} else {
					this.$http
						.post("user/delfo/", {
							id: this.id,
							token: this.$cookies.get("token")
						})
						.then(res => {
							if (res.body.code == 1) {
								this.state = true;
							}
						});
				}
			}
		},
		//生命周期 - 创建完成（可以访问当前this实例）
		created() {},
		//生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {},
		beforeCreate() {}, //生命周期 - 创建之前
		beforeMount() {}, //生命周期 - 挂载之前
		beforeUpdate() {}, //生命周期 - 更新之前
		updated() {}, //生命周期 - 更新之后
		beforeDestroy() {}, //生命周期 - 销毁之前
		destroyed() {}, //生命周期 - 销毁完成
		activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
	};
</script>
<style  scoped>
	.mybtnbox {
		display: flex;
		justify-content: center;
	}
	.follow {
		width: 80px;
		height: 32px;
		border: 0;
		border-radius: 4px;
		background-color: #28a3b1;
		color: #fff;
		font-size: 14px;
		margin: 30px auto 0;
	}

	.follow1 {
		width: 80px;
		height: 32px;
		border: 0;
		border-radius: 4px;
		background-color: #b3b3b3;
		color: #fff;
		font-size: 14px;
		margin: 30px auto 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/follow.vue